export default __webpack_public_path__ + "static/media/stopwatch-red.336c77ef.svg";